/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class ForgeJobController implements angular.IController {
        public jobs: ForgeJobViewModel[];
        $onInit = () => { };

        constructor(private forgeService: ForgeService, private $mdDialog: any, private $rootScope: ng.IRootScopeService) {
            var vm = this;
            this.loadData();
            setInterval(() => {
                vm.loadData();
            }, 20000);
        }

        public loadData() {
            var vm = this;
            this.forgeService.getJobs().then((jobs: ForgeJobViewModel[]) => {
                vm.jobs = jobs;
            });
        }
    }

    ForgeJobController.$inject = ['ForgeService', '$mdDialog', '$rootScope'];

    angular
        .module('eseebase')
        .controller('ForgeJobController', ForgeJobController);
}
